export const parseTagArgs = args => {

  if (!Array.isArray(args)) {
    return [];
  }

  let name;
  let parameters = {};

  for (const arg of args) {

    if (typeof arg !== 'object') {
      continue;
    }

    for (const [paramName, paramValue] of Object.entries(arg)) {

      if (paramName === 'name') {

        name = paramValue;
        continue;
      }

      if (typeof paramValue === 'object') {

        parameters = {
          ...parameters,
          ...paramValue,
        };

        continue;
      }

      parameters[paramName] = paramValue;
    }

    if (name) {
      break;
    }
  }

  return [{
    name,
    parameters,
  }];
};